import React from 'react';
import {View} from 'react-native';

function ProductCard() {
  return <View className="h-[200px] w-full bg-blue-500"></View>;
}

export default ProductCard;
